/* eslint-disable react/jsx-no-bind */
/* eslint-disable react/prop-types */
import { Typography } from '@material-ui/core';
import React, { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import CountyContext from '../../contexts/CountyContext';
import StoryContext from '../../contexts/StoryContext';
import { composeWhereClause, displayChildAge } from '../../modules/data';
import { rdsTabulate } from '../../modules/rds';
import states, { stateFIPS } from '../../modules/states';
import { toFormattedNumber } from '../../modules/text';
import HorizontalBarChart from '../HorizontalBarChart';

function AccessBySettingType({ height = 300 }) {
  const { stateCode } = useParams();
  const [, setReady] = useState(false);
  const [error, setError] = useState(null);
  const [data, setData] = useState([]);
  const { countyCode, county } = useContext(CountyContext);
  const { primaryColor, secondaryColor } = useContext(StoryContext);

  useEffect(() => {
    setError(null);

    // const server = new RdsServer(process.env.REACT_APP_RDS_SERVER);

    async function getData() {
      // Instantiate a catalog that exists on the server
      // const catalog = new RdsCatalog(server, 'ccdc');
      // Instantiate a data product that exists on the catalog
      // const dataProduct = new RdsDataProduct(catalog, 'county_licensed_capacity');
      let whereClause = `state_fips=${stateFIPS[stateCode.toUpperCase()]} AND capacity_type=LIC`;

      whereClause += composeWhereClause({});

      if (countyCode) {
        whereClause += ` AND county_fips=${countyCode}`;
      }

      rdsTabulate('ccdc', 'county_licensed_capacity', {
        dims: 'state_fips,age_group',
        measure: 'capacity:SUM(capacity)',
        where: whereClause,
        format: 'amcharts',
        inject: false,
      })
        .then((result) => {
          const d = result.parsedBody.dataProvider;
          // console.log(d);
          const combined = {};
          d.forEach((item) => { combined[item.age_group] = item; });
          if (combined.INF) {
            combined.INF.capacity += combined.TOD.capacity;
            combined.INF.age_group = 'INF,TOD';
            delete combined.TOD;
          }
          const correctedData = [];
          Object.keys(combined).forEach((k) => { correctedData.push(combined[k]); });

          const total = correctedData.reduce((a, v) => (a + Number.parseInt(v.capacity, 10)), 0);
          const payload = correctedData.map((v) => Object.assign(v, {
            percent: ((v.capacity / total) * 100),
            label: v.age_group ? displayChildAge(v.age_group, true) : 'Not reported by age',
            tooltipLabel: v.age_group ? displayChildAge(v.age_group, true) : null,
          }));
          // console.log(payload)
          setData(payload);
        })
        .catch((rdsError) => {
          setError(rdsError);
        })
        .finally(() => {
          setReady(true);
        });
    }
    if (stateCode && states[stateCode.toUpperCase()]) {
      // fetch actual average price data
      getData();
    }
  }, [stateCode, countyCode]);

  const keys = ['capacity'];
  const groupKey = 'label';

  let title = 'Child Age';
  if (county) {
    title += ` - ${county} County`;
  }

  const tooltipFormatter = function tooltipFormatter(payload) {
    return `${toFormattedNumber(payload.payload.percent)}% are 
    ${payload.payload.tooltipLabel ? `for ${payload.payload.tooltipLabel.toLowerCase()}` : ' not reported by age'}.`;
  };

  return (
    <>
      {error && <Typography variant="body1" color="error">{error.message}</Typography>}
      <HorizontalBarChart
        height={height}
        data={data}
        tooltipFormatter={tooltipFormatter}
        valueFormatter={toFormattedNumber}
        keys={keys}
        groupKey={groupKey}
        title={title}
        colors={[primaryColor, secondaryColor]}
        showYTick
      />
    </>
  );
}

export default AccessBySettingType;
